import { render, staticRenderFns } from "./ManualPurchase.vue?vue&type=template&id=cb1bbb1c&scoped=true"
import script from "./ManualPurchase.vue?vue&type=script&lang=js"
export * from "./ManualPurchase.vue?vue&type=script&lang=js"
import style0 from "./ManualPurchase.vue?vue&type=style&index=0&id=cb1bbb1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1bbb1c",
  null
  
)

export default component.exports